import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-button',
  imports: [
    NgClass
  ],
  templateUrl: './button.html',
  styleUrl: './button.css'
})
export class Button {
  @Input() label = 'Buscar';
  @Input() icon = 'fi-rr-search';
  @Input() color = 'orange-500';
  @Input() disabled = false;

  @Output() clickButton = new EventEmitter<void>();

  onClick() {
    if (this.disabled) return;
    this.clickButton.emit();
  }
}
